<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="4">
        <WelcomeCard />
      </v-col>

      <v-col cols="8">
        <v-sheet class="pa-2 ma-2">
          .v-col-4
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import WelcomeCard from './WelcomeCard.vue'
export default {
  name: 'DashboardHome',
  components:{
    WelcomeCard
  }
};
</script>

<style scoped>
.square-btn {
  width: 36px;      /* Explicit width */
  height: 36px !important;     /* Same as width to ensure square shape */
  padding: 0;       /* Remove extra padding */
  font-size: 12px;  /* Adjust icon size if needed */
}

.v-tooltip > .v-overlay__content {
  font-size: 12px;
}

</style>
